import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Tabs, Tab, Typography, Link } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useHistory } from 'react-router-dom'

import usePermissions from 'hooks/usePermissions'

import {
  ContractForm,
  PaymentsForm,
  PreRegistrationsCard,
  PaymentOrdersCard,
  ServicesCard,
} from './components'

import constants from 'constants/index'
import { routes } from 'Routes'

const TabsForm = ({
  mode,
  preRegistration,
  refresh,
  paymentContract,
  tab,
  setTab,
}) => {
  const location = useLocation()
  const permissions = usePermissions()
  const history = useHistory()

  const tabDefault = location?.state?.tab

  useEffect(() => {
    if (tabDefault) setTab(tabDefault)
    // eslint-disable-next-line
  }, [tabDefault])

  const isNew = mode === 'new'

  const handleChange = (_, value) => {
    setTab(value)
  }

  const goChurns = () =>
    history.push({
      pathname: routes.churns.all,
      search: `?contractIdentifier=${encodeURIComponent(
        paymentContract?.contractIdentifier,
      )}`,
    })

  return (
    <>
      {paymentContract?.haveChurn && (
        <Alert variant="filled" severity="warning">
          <Typography variant="body1">
            Atenção! Este contrato tem solicitações de churns&nbsp;
            <Link component="a" href="#" onClick={goChurns}>
              clique aqui
            </Link>
            &nbsp; para visualizar
          </Typography>
        </Alert>
      )}
      <Tabs value={tab} indicatorColor="primary" textColor="primary">
        {constants.paymentContract.TABS.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            disabled={isNew && tab.value !== 'contract'}
            onClick={(event) => handleChange(event, tab.value)}
          />
        ))}
      </Tabs>
      {tab === 'contract' && (
        <ContractForm
          mode={mode}
          preRegistration={preRegistration}
          refresh={refresh}
          paymentContract={paymentContract}
        />
      )}
      {tab === 'contractor' && (
        <PreRegistrationsCard paymentContract={paymentContract} mode={mode} />
      )}
      {tab === 'payment' && (
        <PaymentsForm
          mode={mode}
          preRegistration={preRegistration}
          paymentContract={paymentContract}
          refresh={refresh}
        />
      )}
      {tab === 'services' && (
        <ServicesCard
          paymentContract={paymentContract}
          mode={mode}
          refreshContract={refresh}
        />
      )}
      {tab === 'paymentOrder' && (
        <>
          {permissions.permitted(constants.permissions.PAYMENT_ORDERS.LIST) ? (
            <PaymentOrdersCard mode={mode} paymentContract={paymentContract} />
          ) : (
            <Alert variant="filled" severity="warning">
              <Typography>
                Você não tem permissão para visualizar as cobranças.
              </Typography>
            </Alert>
          )}
        </>
      )}
    </>
  )
}
export default TabsForm
